import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "@core/config/app.config.service";
import {
  Beneficiarios,
  NovedadesAfiliacion,
  ReqEliminarReservaUuid
} from "@features/interfaces/ael-interfaces/registros.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReservaService {
  constructor(
    private readonly _http: HttpClient,
    private readonly _configService: ConfigService,
  ) { }


  private currentUuid: string | null = null;

  private get urlCrearReserva(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/crear-reserva`;
  }

  private get urlActualizarCompraReserva(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/actualizar-compra-reserva`;
  }

  private get urlCrearAfiliacion(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/crear-afiliacion`;
  }

  private get urlCrearBeneficiarios(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/crear-beneficiarios`;
  }

  private get urlNovedadesAfiliacion(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/insertar-novedad-afiliaciones`;
  }

  private get urlEliminarReserva(): string {
    return `${this._configService.config.apiUrls.urlGatewayProcesos}/registros/eliminar-reserva`
  }

  public getUuid(): string | null {
    return this.currentUuid;
  }

  public setUuid(uuid: string | null): void {
    this.currentUuid = uuid;
  }

  public crearReserva = (
    idEmpleador: number,
    idUsuario: number,
    cantidad: number,
    id_compra: number
  ): Observable<any> => {

    if (!this.currentUuid)
      this.currentUuid = crypto.randomUUID();

    const data = {
      id_empleador: idEmpleador,
      id_usuario: idUsuario,
      cantidad,
      id_compra,
      uuid: this.currentUuid
    };

    return this._http.post(`${this.urlCrearReserva}`, data);
  };

  public eliminarReserva = (
    data: ReqEliminarReservaUuid,
  ): Observable<any> => {
    return this._http.post(`${this.urlEliminarReserva}`, data);
  };

  public actualizarCompraReserva = (
    idEmpleador: number,
    idUsuario: number,
    cantidad: number,
  ): Observable<any> => {
    const data = {
      id_empleador: idEmpleador,
      id_usuario: idUsuario,
      cantidad,
    };
    return this._http.post(`${this.urlActualizarCompraReserva}`, data);
  };

  public crearAfiliacion = (data: any): Observable<any> => {
    return this._http.post(`${this.urlCrearAfiliacion}`, data);
  };

  public crearBeneficiarios = (data: Array<Beneficiarios>): Observable<any> => {
    return this._http.post(`${this.urlCrearBeneficiarios}`, data);
  };

  public crearNovedadAfiliacion = (
    data: NovedadesAfiliacion,
  ): Observable<any> => {
    return this._http.post(`${this.urlNovedadesAfiliacion}`, data);
  };
}
